import { styled } from "sharedUI/styles";

export const OrgsScreenStyle = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;

    display: flex;

    background-color: ${p => p.theme.bgColorAltLight};

    & > :not(:first-child) {
        flex: 1;
        position: relative;
    }

    & .oss-loading-overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;

        background-color: ${p => p.theme.bgColorLightTransparent};

        animation: fadein 0.2s;
        animation-iteration-count: 1;

        @keyframes fadein {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
    }
`;
